<template>
  <div v-if="normalizedGroups.length" class="base-filter d-flex flex-wrap align-center">
    <div
      v-for="group in normalizedGroups"
      :key="group.key"
      class="base-filter-group d-flex flex-wrap align-center"
    >
      <span v-if="group.label" class="base-filter-label text-no-wrap mr-2">
        {{ group.label }}
      </span>
      <v-btn
        v-for="option in group.options"
        :key="group.key + '-' + option.value"
        x-small
        class="mx-1 my-1 base-filter-option"
        depressed
        :color="isActive(group, option.value) ? 'primary' : ''"
        @click="toggle(group, option.value)"
      >
        <v-icon v-if="option.icon" left small>{{ option.icon }}</v-icon>
        {{ option.label }}
      </v-btn>
    </div>

    <v-btn
      v-if="clearable && hasActiveFilters"
      small
      text
      class="base-filter-clear ml-auto"
      @click="clear"
    >
      {{ clearLabel }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "BaseFilter",
  props: {
    // [{ key, label, multiple, mandatory, options: [{ value, label, icon }] }]
    groups: {
      type: Array,
      default: () => [],
    },
    // { [group.key]: selectedValue(s) } - array when multiple, scalar otherwise
    value: {
      type: Object,
      default: () => ({}),
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    clearLabel: {
      type: String,
      default: "Clear",
    },
  },
  computed: {
    normalizedGroups() {
      return this.groups.map((group) => ({
        multiple: true,
        mandatory: false,
        options: [],
        ...group,
      }));
    },
    hasActiveFilters() {
      return this.normalizedGroups.some((group) => {
        const current = this.value[group.key];
        return group.multiple
          ? !!(current && current.length)
          : current !== null && current !== undefined && current !== "";
      });
    },
  },
  methods: {
    isActive(group, optionValue) {
      const current = this.value[group.key];
      return group.multiple
        ? !!(current || []).includes(optionValue)
        : current === optionValue;
    },
    toggle(group, optionValue) {
      const current = this.value[group.key];
      let next;

      if (group.multiple) {
        const list = current || [];
        next = list.includes(optionValue)
          ? list.filter((v) => v !== optionValue)
          : [...list, optionValue];
      } else if (group.mandatory && current === optionValue) {
        next = current;
      } else {
        next = optionValue;
      }

      this.emitChange(group.key, next);
    },
    clear() {
      const next = { ...this.value };
      this.normalizedGroups.forEach((group) => {
        next[group.key] = group.multiple ? [] : null;
      });
      this.$emit("input", next);
      this.$emit("clear");
    },
    emitChange(key, next) {
      const updated = { ...this.value, [key]: next };
      this.$emit("input", updated);
      this.$emit("change", { key, value: next });
    },
  },
};
</script>

<style scoped>
.base-filter-clear {
  margin-left: auto;
}
</style>
